export type LanguageCode = 'en' | 'es' | 'fr';

export type Language = {
    code: LanguageCode;
    email: string;
    password: string;
    signIn: string;
    forgotPassword: string;
    incorrectCreds: string;
    loginFailure: string;
    /** Default shown for a 400 when CABES sends no usable exceptionMessage. */
    badRequest: string;
    /** Shown under the email field when it loses focus holding a malformed address. */
    invalidEmail: string;
};

export const TRANSLATIONS: Record<LanguageCode, Language> = {
    en: {
        code: 'en',
        email: 'Email',
        password: 'Password',
        signIn: 'Sign in',
        forgotPassword: 'Forgot password?',
        incorrectCreds: "Email or password does not match our records. Please try again.",
        loginFailure: "Something isn't working right. Please try again.",
        badRequest: 'Fields must not be blank.',
        invalidEmail: 'Enter a valid email address',
    },
    es: {
        code: 'es',
        email: 'Correo electrónico',
        password: 'Contraseña',
        signIn: 'Iniciar sesión',
        forgotPassword: '¿Has olvidado tu contraseña?',
        incorrectCreds: 'El correo electrónico o la contraseña no coinciden con nuestros registros. Por favor, inténtalo de nuevo.',
        loginFailure: 'Algo no está funcionando correctamente. Por favor, inténtalo de nuevo.',
        badRequest: 'Los campos no pueden estar vacíos.',
        invalidEmail: 'Introduce un correo electrónico válido',
    },
    fr: {
        code: 'fr',
        email: 'Courriel',
        password: 'Mot de passe',
        signIn: 'Se connecter',
        forgotPassword: 'Mot de passe oublié?',
        incorrectCreds: 'Le courriel ou le mot de passe ne correspond pas à nos dossiers. Veuillez réessayer.',
        loginFailure: 'Un problème est survenu. Veuillez réessayer.',
        badRequest: 'Les champs ne doivent pas être vides.',
        invalidEmail: 'Entrez un courriel valide',
    },
};
